import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';
import ConfirmModal from '../components/ConfirmModal'; 

const DeleteAccount = () => {
  const [userData, setUserData] = useState({ phone: '', user_name: '' });
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const userDetails = response.data.data.user_details;
        const user = response.data.data.user;
        setUserData({ ...userDetails, user_name: user.user_name });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user details', error);
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleDeleteAccount = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    try {
      await axios.delete(`${config.baseURL}/delete-user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Remove token and redirect to login
      localStorage.removeItem('token');
      navigate('/Login');
    } catch (error) {
      console.error('Error deleting account', error);
    }
  };

  const handleConfirmDelete = () => {
    handleDeleteAccount();
    setShowModal(false);
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={(e) => {
                e.preventDefault();
                setShowModal(true); // Show modal on form submission
              }}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">                    
                    <h1>Delete account</h1>
                  </div>
                </div>
                <div className="fields_menu_bottom_box_edit_account edit_username_fields">
                  <div className="editable_fields_user social_account_settings delete_account_block">
                    <div className="mb-4 position_relative">
                      <button type="submit" className="delete_account create_post_btn_area post_btn">Delete account</button>
                    </div>
                    <div className="divider_line"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal show={showModal} onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} />
    </div>
  );
};

export default DeleteAccount;
